import {configParamsModule} from "./configParamsModule";
import {IntegrationService} from "../integration/integrationService";
import {R2IntegrationSysParams} from "../integration/R2IntegrationSysParams";
import {ConfigParamsService} from "./configParamsService";
import {LoadingService, MessagesModal, RemoteExceptionHandler} from "../../bower_components/front-end-web-commons";
import {IQService} from "angular";
import {RemoteServersModalService} from "./remoteServer/remoteServersModalService";
import {PathProvider} from "./model/PathProvider";

class ConfigParamsController {
    private integrationConfig: R2IntegrationSysParams;
    private pathProvider: PathProvider;

    constructor(private integrationService: IntegrationService,
                private configParamsService: ConfigParamsService,
                private loadingService: LoadingService,
                private remoteExceptionHandler: RemoteExceptionHandler,
                private messagesModal: MessagesModal,
                private remoteServerModalService: RemoteServersModalService,
                private $q: IQService
    ) {
        this.loadingService($q.all([this.loadIntegration(), this.loadPathProvider()]))
            .catch(this.remoteExceptionHandler())
    }

    private loadIntegration() {
        return this.integrationService.getIntegrationConfig()
            .then(integrationConfig => this.integrationConfig = integrationConfig)
    }

    private loadPathProvider() {
        return this.configParamsService.getPathProviderType()
            .then(pathProvider => this.pathProvider = pathProvider)
    }

    updateAllUrls(integrationUrl) {
        return this.loadingService(this.integrationService.updateAllUrls(integrationUrl)
            .catch(this.remoteExceptionHandler())
            .then(() => {
                this.messagesModal("dialog.success", ["config.params.success"])
                    .then(() => this.loadIntegration())
            }));
    }

    testConnectivity(url: string) {
        return this.loadingService(this.integrationService.testConnectivity(url))
            .catch(this.remoteExceptionHandler())
            .then((status: boolean) => {
                if (status === true) {
                    this.messagesModal("dialog.success", ["integration.connectivity.ok"]);
                } else {
                    this.messagesModal("dialog.error", ["integration.connectivity.error"]);
                }
            })
    }

    clearServerCache() {
        return this.loadingService(this.configParamsService.clearServerCache()
            .then(() => this.messagesModal("dialog.success", ["config.params.clear.cache.success"])
            )).catch(this.remoteExceptionHandler())
    }

    clearIntegrationCache() {
        return this.loadingService(this.configParamsService.clearIntegrationCache())
            .catch(this.remoteExceptionHandler())
    }

    routerServer() {
        return this.remoteServerModalService.open()
    }

    getPathProviderTypes() {
        return this.configParamsService.getPathProviderTypes();
    }

    updatePathProvider() {
        if (!this.pathProvider.type) {
            return;
        }
        this.loadingService(this.configParamsService.updatePathProvider(this.pathProvider))
            .then( () => this.messagesModal("dialog.success", ["config.params.success"]))
            .catch(this.remoteExceptionHandler())
    }
}

configParamsModule.controller("configParamsController", ConfigParamsController)